export default __webpack_public_path__ + "static/media/5.fc2c7f4e.webp";